module.exports = __webpack_public_path__ + "media/images/icons/absent-color-icon-5199a4a3164d1b48646fb77670baae4f.svg";